import React from 'react';
import { toDisplayFormat, toDateInputFormat } from '../../utlis/dateUtils';

const InvoiceMeta = ({ 
  inv_number,
  invoiceNo, 
  invoiceDate, 
  placeOfSupply, 
  isEditable, 
  setInvoiceData 
}) => {
  
  // Convert date to input format when editing
  const displayDate = isEditable ? toDateInputFormat(invoiceDate) : invoiceDate;

  const handleDateChange = (e) => {
    const yyyymmdd = e.target.value;
    // Convert back to DD-MM-YYYY when saving
    const ddmmyyyy = toDisplayFormat(yyyymmdd);
    setInvoiceData(prev => ({ ...prev, invoiceDate: ddmmyyyy }));
  };

  return (
    <div className="invoice-meta">
      <p>
        <strong>Invoice Number:</strong>
        {isEditable ? (
          <input
            type="text"
            value={inv_number}
            onChange={(e) => setInvoiceData(prev => ({ ...prev, inv_number: e.target.value }))}
          />
        ) : (
          <span>{inv_number}</span>
        )}
      </p>
      <p>
        <strong>Invoice No:</strong>
        {isEditable ? (
          <input
            type="text"
            value={invoiceNo}
            onChange={(e) => setInvoiceData(prev => ({ ...prev, invoiceNo: e.target.value }))}
          />
        ) : (
          <span>{invoiceNo}</span>
        )}
      </p>
      <p>
        <strong>Invoice Date:</strong>
        {isEditable ? (
          <input
            type="date"
            value={displayDate}
            onChange={handleDateChange}
          />
        ) : (
          <span>{(invoiceDate)}</span>
        )}
      </p>
      <p>
        <strong>Place of Supply:</strong>
        {isEditable ? (
          <input
            type="text"
            value={placeOfSupply}
            onChange={(e) => setInvoiceData(prev => ({ ...prev, placeOfSupply: e.target.value }))}
          />
        ) : (
          <span>{placeOfSupply}</span>
        )}
      </p>
    </div>
  );
};

export default InvoiceMeta;
